module.exports = __webpack_public_path__ + "assets/img/zhop_logo3.9b264697.svg";